module.exports = __webpack_public_path__ + "static/media/kokeza.b9cf21d3.jpg";